import Api from '@/services/Api';

export default {
    createTask(data: any) {
        return Api().post('tasks', data,  {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-type': 'application/json'
            }
        });
    },
};
